export default __webpack_public_path__ + "static/media/lifestyle-control.a14810c5.jpg";